function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 14.4444C12.4546 14.4444 14.4444 12.4546 14.4444 10C14.4444 7.5454 12.4546 5.55556 10 5.55556C7.5454 5.55556 5.55556 7.5454 5.55556 10C5.55556 12.4546 7.5454 14.4444 10 14.4444ZM10 12.2222C8.7727 12.2222 7.77778 11.2273 7.77778 10C7.77778 8.7727 8.7727 7.77778 10 7.77778C11.2273 7.77778 12.2222 8.7727 12.2222 10C12.2222 11.2273 11.2273 12.2222 10 12.2222Z",
  fill: "#8798AD",
  className: "svg-fill"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 9.85562C0 4.4084 4.48119 0 10 0C15.5188 0 20 4.4084 20 9.85562C20 12.5463 18.8994 15.0663 16.9945 16.8992L10.7793 23.0143C10.3469 23.4397 9.6532 23.4397 9.22079 23.0143L2.99705 16.8916C1.09382 15.051 0 12.538 0 9.85562ZM15.4448 15.3066C16.9285 13.8788 17.7778 11.9343 17.7778 9.85562C17.7778 5.64392 14.2996 2.22222 10 2.22222C5.70042 2.22222 2.22222 5.64392 2.22222 9.85562C2.22222 11.9279 3.06627 13.8671 4.5487 15.3008L9.99996 20.6635L15.4448 15.3066Z",
  fill: "#8798AD",
  className: "svg-fill"
});

var SvgLocal = function SvgLocal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/local.fd061fa5.svg";
export { ForwardRef as ReactComponent };